import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
    Form,
    Row,
    Col,
    Modal,
    message,
    Popconfirm,
    Spin,
    Select,
    Button,
    Icon,
    Table,
    Input,
    InputNumber,
    DatePicker,
    TimePicker,
    Radio,
    Checkbox,
    Calendar,
    Slider,
} from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import { dateConversion, stringToTime, showDate,timeStampToStr,delayTimeToFinishTime } from '../../../utils';
import {
    getList,
    getProvinceList,
    getTaskId,
    createEditShowAction,
    submitToMD,
    insertToMD,
    createEditTimeAction,
    createEditOverflowRateAction,
    createEditIpReusedTimesAction,
    createEditTaskTypeAction,
    createEditAndroidRatioAction,
    createEditEngineAction,
    createEditWaitTimeoutAction,
    createEditPvToUvRatioAction,
    createEditForceWaitAction,
    createEditProvinceAction,
    createEditTaskSource,
    createEditTrackDelayTime,
    createEditTaskPosition,
    getPrimaryAndOtherScript,
    getClusterList,
    getOutTaskCategoryList,
    getGroupList,
    getAgentsAndAreas,
    getLabelList,
    createEditTimePairsAction,
    createEditMainScriptAction,
    createEditScriptAction,
    getCurveList,
    changeEditInfo,
    getMonitorList,
} from './actions';
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const CheckboxGroup = Checkbox.Group;
const { TextArea } = Input;
import data from './data';
import BehaviourMask from './changeBehaviour';
import TimePairsSelect from './TimePairsSelect.js'
import PvcRatio from './PvcRatio.js'
let dataArray = [];
let user = JSON.parse(localStorage.getItem('HippoUserInfo'));
let today = dateConversion(Date.parse(new Date()));
class EditTask extends Component {
    constructor(props) {
        super(props); // 调用super父类构造函数改变this指向
        this.state = {
            role: user.role || 0,
            // taskPosition: 'DEFAULT',
            editBehavior: false,
        };
    }

    componentDidMount() {
        this.props.getProvinceList();
        this.props.getScripts();
        this.props.getClusterList();
        this.props.getOutTaskCategoryList();
        this.props.getGroupList();
        this.props.getAgentsAndAreas();
        this.props.getLabelList();
        this.props.getCurveList();
        this.props.getMonitorList();
    }

    concatData = (data, newData) => {
        for (var n = 0; n < data.length; n++) {
            let item = data[n];
            if (item.taskId == newData.taskId) {
                item = Object.assign(item, newData);
                break;
            } else {
                this.concatData(item.subTasks, newData);
            }
        }
        return data;
    };
    // changeTaskPosition = value => {
    //     console.log(value);
    //     if (this.state.role == 1) {
    //         this.props.updateTaskPosition(value);
    //     }
    // };
    changeEditHide = () => {
        this.props.changeEditStatus(false);
        this.props.form.resetFields();
    };
    async handleChange(value) {
        await this.props.updateTaskType(value);
        if (value == 'CLICK') {
            await this.props.updateIpReusedTimes(1);
            await this.props.updateWaitTimeout(40);
            await this.props.updatePvToUvRatio(100);
            await this.props.updateForceWait(30);
        } else {
            await this.props.updateIpReusedTimes(30);
            await this.props.updateWaitTimeout(5);
            await this.props.updatePvToUvRatio(50);
            await this.props.updateForceWait(0);
        }
        if (value !== 'COMBINE_EV_CLICK') {
            await this.props.changeEditInfo({
                clickTargetPv: 0,
                isEvClick: null,
                clickIpReusedTimes: 0,
                clickWaitTimeout: 0,
            });
        }
    };
    async handleChangeDeviceInfo(value) {
        if (value == 'DEFAULT') {
            await this.props.updateAndroidRatio(70);
        } else if (value == 'ANDROID') {
            await this.props.updateAndroidRatio(100);
        } else {
            await this.props.updateAndroidRatio(0);
        }
    }
    async handleEngine(value) {
        if (this.props.editInfo.engine != value) {
            await this.props.updateMainScript();
            await this.props.updateScript('');
            await this.props.updateEngine(value);
        }
        console.log(this.props.editInfo.engine);
    };

    changeFlow = e => {
        this.props.updateOverflow(e.target.value);
    };
    changeTaskSource = e => {
        if(e.target.value == 'accurateOperations'){
          this.props.updateTimePairs([{'beginTime':0,'endTime':2359}]);
        } else {
          this.props.updateTimePairs([{'beginTime':930,'endTime':2359}]);
        }
        this.props.updateTaskSource(e.target.value);
    };
    
    handleTrackDelayTime = e => {
       this.props.updateTrackDelayTime(e);
   }
    async selectData(value) {
        const data = value.format('YYYY-MM-DD');
        let repate = false;
        let dataList = this.props.editInfo.filtration ? this.props.editInfo.filtration : [];
        for (let i = 0; i < dataList.length; i++) {
            if (dataList[i] == data) {
                repate = true;
                // alert('已选择');
                this.removeData(i);
                return;
            }
            repate = false;
        }

        if (!repate) {
            dataList.push(value.format('YYYY-MM-DD'));
            this.props.updateTime(dataList);
        }
    };
    removeData = index => {
        let dataList = this.props.editInfo.filtration;
        dataList = dataList.filter((v, k) => {
            return index != k;
        });
        this.props.updateTime(dataList);
    };
    dateCellRender = value => {
        return this.props.editInfo.filtration.map(
            item =>
                item == value.format('YYYY-MM-DD') ? (
                    <div
                        style={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            width: 22,
                            height: 22,
                            lineHeight: '22px',
                            backgroundColor: '#108ee9',
                            color: '#fff',
                            borderRadius: '4px',
                        }}>
                        {showDate(item)}
                    </div>
                ) : null,
        );
    };
    async submit(i) {
        this.props.form.validateFields(async (err, fieldsValue) => {
            console.log(this.props.editInfo.overflowRate != 10 && this.props.editInfo.overflowRate != 20 && this.props.editInfo.overflowRate != 30);
            if (!err) {
                try {
                    if(fieldsValue.overflowRate == 40 && (fieldsValue.overflow == undefined || fieldsValue.overflow == '')){
                      alert('请输入自定义溢出量！！！');
                      return;
                    }
                    fieldsValue.filtration = this.props.editInfo.filtration;
                    fieldsValue.behaviourData = this.props.editInfo.behaviourData;
                   /* fieldsValue.beginTime = fieldsValue.beginTime.format('HH:mm');
                    fieldsValue.endTime = fieldsValue.endTime.format('HH:mm');*/
                   /* fieldsValue.timePairs = [
                        {
                            beginTime: fieldsValue.beginTime.replace(':', ''),
                            endTime: fieldsValue.endTime.replace(':', ''),
                        },
                    ];*/
                    fieldsValue.timePairs = this.props.editInfo.timePairs;
                    fieldsValue.overflowRate =
                        fieldsValue.overflowRate == 40
                            ? parseInt(fieldsValue.overflow)
                            : parseInt(fieldsValue.overflowRate);
                    fieldsValue.api =
                        (fieldsValue.taskSource == 'api' || fieldsValue.taskSource == 'accurateOperations' || fieldsValue.taskSource == 'lookalike' || fieldsValue.taskSource =='brandDsp') ?
                            fieldsValue.api
                            : '';
                    fieldsValue.interest =
                        (fieldsValue.taskSource == 'accurateOperations' || fieldsValue.taskSource == 'lookalike') ?
                            fieldsValue.interest
                            : [];
                    fieldsValue.userInfo =
                        (fieldsValue.taskSource == 'accurateOperations' || fieldsValue.taskSource == 'lookalike') ?
                            fieldsValue.userInfo
                            : [];
                    fieldsValue.overflow =
                        this.props.editInfo.overflowRate == 40
                            ? parseInt(fieldsValue.targetPv * fieldsValue.overflow / 100)
                            : parseInt(fieldsValue.targetPv * fieldsValue.overflowRate / 100);
                    //: parseInt(fieldsValue.targetPv * this.props.editInfo.overflowRate / 100);
                    if (fieldsValue.androidRatio) {
                      fieldsValue.iosRatio = 100 - fieldsValue.androidRatio;
                    }
                    if (this.props.editInfo.filtration.length <= 0) {
                        alert('请选择启用时间');
                        return;
                    }
                    // if (this.props.editInfo.taskPosition != 'DEFAULT' && fieldsValue.scriptPath === undefined) {
                    //     message.error('广告位置不是默认时,脚本路径为必填项');
                    //     return;
                    // }
                    if (i == 0) {
                        //修改
                        fieldsValue.taskId = this.props.editInfo.taskId;
                        fieldsValue.createTime = new Date(this.props.editInfo.createTime);
                        let treeRoot = [];
                        treeRoot.push(this.props.root);
                        const sendData = this.concatData(treeRoot, fieldsValue);
                        await this.props.toSubmit(sendData[0]);
                    } else if (i == 1) {
                        //新增
                        fieldsValue.eId = this.props.editInfo.eId;
                        fieldsValue.actions = [];
                        fieldsValue.subTasks = [];
                        fieldsValue.status = 0;
                        fieldsValue.createTime = new Date();
                        fieldsValue.parentId = '0';
                        await this.props.toInsert(fieldsValue);
                    }

                    await this.props.form.resetFields();

                    await this.props.getList(this.props.listState);
                } catch (err) {
                    console.log(err);
                    alert(err);
                }
            } else {
                console.log(fieldsValue);
                console.log(err);
            }
        });
    };
    showBehaviourEdit = () => {
        // 显示编辑行为数据的层
        if (this.props.editInfo.behaviourData) {
            this.setState({editBehavior: true});
        } else {
            message.error('行为数据为空');
        }

    }
    hideBehaviorMask = () => {
        this.setState({editBehavior: false});
    }
    changeBehaviourData = e => {
        this.props.changeEditInfo({behaviourData: e.target.value});
    }
    render() {
        const { getFieldDecorator, onPanelChange } = this.props.form;
        const { editBehavior } = this.state;
        const { accountList,topId, addType, editStatus, editInfo, provinceList, primaryScripts,curveList ,otherScripts, clusterList, outTaskCategoryList=[],groupList, agents,labelList,userList ,moniterNameList} = this.props;
        const marks = {
            0: '0',
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            10: {
              style: {
                color: '#f50',
              },
              label: <strong>10</strong>,
            },
        };
        const formItemLayout = {
            labelCol: {
                xs: { span: 18 },
                sm: { span: 6 },
            },
            wrapperCol: {
                xs: { span: 18 },
                sm: { span: 14 },
            },
        };
        return (
            <div>
                <Modal
                    title="编辑任务"
                    visible={editStatus}
                    onCancel={() => this.changeEditHide()}
                    onOk={() => {
                        this.submit(0);
                    }}
                    footer={[
                        <Button key="back" size="large" onClick={() => this.changeEditHide()}>取消</Button>,
                        <Button key="update" type="primary" size="large" onClick={() => {
                            this.submit(0);
                        }}>修改</Button>,
                        <Popconfirm placement="topLeft" title={"确定新增？"} onConfirm={() => {
                            this.submit(1);
                        }} okText="是" cancelText="否">
                            <Button key="submit" type="primary" size="large" >新增</Button>
                        </Popconfirm>
                            ,

                    ]}
                >
                    <Form>
                        <FormItem {...formItemLayout} label="订单名称">
                            {getFieldDecorator('taskDescription', {
                                initialValue: editInfo.taskDescription,
                                rules: [
                                    {
                                        type: 'string',
                                        required: true,
                                        message: '请输入订单名称',
                                    },
                                ],
                            })(<TextArea />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务名称">
                            {getFieldDecorator('taskName', {
                                initialValue: editInfo.taskName,
                                rules: [
                                    {
                                        type: 'string',
                                        required: true,
                                        message: '请输入任务名称',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否是外部任务">
                            {getFieldDecorator('isOutAd', {
                                initialValue: editInfo.isOutAd,
                            })(
                                <Select>
                                    <Option value={0}>否</Option>
                                    <Option value={1}>是</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="任务类型">
                            {getFieldDecorator('taskType', {
                                initialValue: editInfo.taskType,
                                rules: [{ required: true, message: '请选择类型' }],
                            })(
                                <Select onChange={this.handleChange.bind(this)}>
                                    <Option value="EV">曝光</Option>
                                    <Option value="CLICK">点击</Option>
                                    <Option value='APPLAUNCH'>APP拉起</Option>
                                    <Option value='COMBINE_EV_CLICK'>合并</Option>
                                    <Option value='APP_RETAIN'>注册留存</Option>
                                    <Option value='RE'>注册</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {(editInfo.taskType === 'APP_RETAIN'|| editInfo.taskType === 'APPLAUNCH') ? (
                            <div>
                                <FormItem {...formItemLayout} label="账号信息">
                                    {getFieldDecorator('accountKey', {
                                        initialValue: editInfo.accountKey,
                                        rules: [{ required: false, message: '请选择' }],
                                    })(
                                        <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                            {accountList.map((item, index) => {
                                                return (
                                                    <Option key={index} value={item.redisKey}>
                                                        {item.accountName}
                                                    </Option>
                                                );
                                            })}
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="是否打码">
                                    {getFieldDecorator('needHitCode', {
                                        initialValue: editInfo.needHitCode,
                                    })(
                                        <Select>
                                            <Option value={0}>否</Option>
                                            <Option value={1}>是</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="是否接码">
                                    {getFieldDecorator('needReceiveCode', {
                                        initialValue: editInfo.needReceiveCode,
                                    })(
                                        <Select>
                                            <Option value={0}>否</Option>
                                            <Option value={1}>是</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="代理模式">
                                    {getFieldDecorator('proxyModel', {
                                        initialValue: editInfo.proxyModel,
                                    })(
                                        <Select>
                                            <Option value={0}>VPN</Option>
                                            <Option value={1}>SYSPOXY</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                            </div>
                        ):''
                        }
                        <FormItem {...formItemLayout} label="外部任务分类">
                            {getFieldDecorator('outType',{
                                initialValue: editInfo.outType,
                            })(
                                <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                {outTaskCategoryList.map((outTaskCategory, index) => {
                                    return (
                                        <Option key={outTaskCategory.categoryId}  title={outTaskCategory.name} value={outTaskCategory.categoryId}>
                                            {outTaskCategory.name}
                                        </Option>
                                    );
                                })}
                            </Select>
                                // <Select>
                                //     <Option value={1}>F+</Option>
                                //     <Option value={null}>空</Option>
                                //     <Option value={2}>其他外部任务</Option>
                                // </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="安卓ios 分离">
                            {getFieldDecorator('iosAndroidIPSame', {
                                initialValue: editInfo.iosAndroidIPSame,
                            })(
                                <Select>
                                    <Option value={0}>否</Option>
                                    <Option value={1}>是</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {editInfo.taskType === 'COMBINE_EV_CLICK' ? (
                            <div>
                                <FormItem {...formItemLayout} label="点击目标量">
                                    {getFieldDecorator('clickTargetPv', {
                                        initialValue: editInfo.clickTargetPv,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入点击目标量',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="是否点击任务">
                                    {getFieldDecorator('isEvClick', {
                                        initialValue: editInfo.isEvClick,
                                        rules: [{ required: true, message: '请选择' }],
                                    })(
                                        <Select>
                                            <Option value={0}>否</Option>
                                            <Option value={1}>是</Option>
                                        </Select>,
                                    )}
                                </FormItem>
                                <FormItem {...formItemLayout} label="ip利用次数">
                                    {getFieldDecorator('clickIpReusedTimes', {
                                        initialValue: editInfo.clickIpReusedTimes,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入ip利用次数',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                                <FormItem {...formItemLayout} label="点击等待时长">
                                    {getFieldDecorator('clickWaitTimeout', {
                                        initialValue: editInfo.clickWaitTimeout,
                                        rules: [
                                            {
                                                required: true,
                                                message: '请输入点击等待时长',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                            </div>
                        ) : ''}

                        {editInfo.taskSource === 'brandDsp' ? (
                            <div>
                                <FormItem {...formItemLayout} label="线索信息">
                                    {getFieldDecorator('clue', {
                                        initialValue: editInfo.clue,
                                        rules: [
                                            {
                                                required: false,
                                                message: '输入线索信息',
                                            },
                                        ],
                                    })(<Input />)}
                                </FormItem>
                            </div>
                        ) : ''}

                        <FormItem {...formItemLayout} label="APP唤醒方式">
                            {getFieldDecorator('appWake', {
                                initialValue: editInfo.appWake,
                            })(
                                <Select>
                                    <Option value={0}>h5</Option>
                                    <Option value={1}>Dpl拉起</Option>
                                    <Option value={2}>Ulk拉起</Option>
                                    {/* <Option value="0">h5</Option>
                                    <Option value="1">Dpl拉起</Option> */}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="成功判定标准">
                            {getFieldDecorator('succStandard', {
                                initialValue: editInfo.succStandard,
                            })(
                                <Select>
                                    <Option value={0}>无</Option>
                                    <Option value={1}>UTDID</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="指定设备号前缀">
                            {getFieldDecorator('deviceRedisKeyPreFix', {
                                initialValue: editInfo.deviceRedisKeyPreFix ,
                            })(<Input />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="UA标识">
                            {getFieldDecorator('uaFlag', {
                                initialValue: editInfo.uaFlag,
                            })(
                                <Select>
                                    <Option value={1}>ZhiHu</Option>
                                    <Option value={2}>BV</Option>
                                    <Option value={3}>YK</Option>
                                    <Option value={4}>YD</Option>
                                    <Option value={5}>MX</Option>
                                    <Option value={6}>M7</Option>
                                    <Option value={7}>Y8</Option>
                                    <Option value={8}>P4</Option>
                                    <Option value={9}>tT</Option>
                                    <Option value={10}>Mogo</Option>
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="iOS设备库ID">
                            {getFieldDecorator('iosUaPathId', {
                                initialValue: editInfo.iosUaPathId ,
                            })(<Input />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="Android设备库ID">
                            {getFieldDecorator('androidUaPathId', {
                                initialValue: editInfo.androidUaPathId ,
                            })(<Input />)}
                        </FormItem>


                        <FormItem {...formItemLayout} label="苹果UA分布">
                            {getFieldDecorator('iosUaVersion', {
                                initialValue: editInfo.iosUaVersion ,
                            })(<Input />)}
                        </FormItem>

                        <FormItem {...formItemLayout} label="安卓UA分布">
                            {getFieldDecorator('androidUaVersion', {
                                initialValue: editInfo.androidUaVersion ,
                            })(<Input />)}
                        </FormItem>


                        <FormItem {...formItemLayout} label="任务来源">
                            {getFieldDecorator('taskSource', {
                                initialValue: editInfo.taskSource,
                            })(
                                <RadioGroup onChange={this.changeTaskSource}>
                                    <Radio value={'ifengad'}>IFENGAD</Radio>
                                    <Radio value={'dmp'}>DMP</Radio>
                                    <Radio value={'api'}>API</Radio>
                                    <Radio value={'dol'}>传漾</Radio>
                                    <Radio value={'accurateOperations'}>精准运营</Radio>
                                    <Radio value={'lookalike'}>追投</Radio>
                                    <Radio value={'js'}>脚本投放</Radio>
                                    <Radio value={'brandDsp'}>brandDsp</Radio>
                                    {/* <Radio value={'applaunch'}>APP拉起</Radio> */}
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="app包名">
                              {getFieldDecorator('packageName', {
                                  initialValue: editInfo.packageName
                              })(<Input />)}
                        </FormItem>
                        {/* {(editInfo.taskType == 'APPLAUNCH' || editInfo.taskType == 'APP_RETAIN'? (
                          <FormItem {...formItemLayout} label="app包名">
                              {getFieldDecorator('packageName', {
                                  initialValue: editInfo.packageName
                              })(<Input />)}
                          </FormItem>
                        ) : null)} */}
                        <FormItem {...formItemLayout} label="留存比例">
                            {getFieldDecorator('retainRatio', {
                                initialValue: editInfo.retainRatio,
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确的留存比例',
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        {(editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="是否获取素材">
                              {getFieldDecorator('requestElement', {
                                  initialValue: editInfo.requestElement,
                              })(
                                  <RadioGroup>
                                      <Radio value={0}>开启</Radio>
                                      <Radio value={1}>关闭</Radio>
                                  </RadioGroup>,
                              )}
                            </FormItem>
                        ) : null)}
                        {(editInfo.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="追投任务Id">
                                {getFieldDecorator('lookalikeTaskId', {
                                    initialValue: editInfo.lookalikeTaskId,
                                })(<Input />)}
                            </FormItem>
                        ) : null)}
                        {(editInfo.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="追投订单Id">
                                {getFieldDecorator('lookalikeOrderId',{
                                    initialValue: editInfo.lookalikeOrderId,
                                })(<Input />)}
                            </FormItem>
                        ) : null)}
                        {(editInfo.taskSource == 'lookalike' ? (
                            <FormItem {...formItemLayout} label="追投标签">
                                {getFieldDecorator('lookalikeTag', {
                                    initialValue: editInfo.lookalikeTag,
                                })(<Input />)}
                            </FormItem>
                        ) : null)}
                        <FormItem {...formItemLayout} label="设备Id利用次数">
                            {getFieldDecorator('deviceIdReusedTimes', {
                                initialValue: editInfo.deviceIdReusedTimes,
                                rules: [
                                    {
                                        pattern: /^\d+$/,
                                        message: '请输入正确利用次数',
                                    },
                                ],
                            })(<Input style={{width:'50%'}}/>)}
                            {getFieldDecorator('deviceIdDiffByTaskOrEid', {
                                initialValue: editInfo.deviceIdDiffByTaskOrEid,
                            })(
                                <Select placeholder="控制域" style={{width:'50%'}}>
                                    <Option value={0}>根据taskId</Option>
                                    <Option value={1}>根据eId</Option>
                                    <Option value={2}>用完即删</Option>
                                    <Option value={3}>按周控制</Option>
                                    <Option value={4}>根据广告位</Option>
                                    <Option value={5}>联合控制</Option>
                                    <Option value={6}>只用历史号</Option>
                                    <Option value={7}>历史号最低频次</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="API">
                                {getFieldDecorator('api', {
                                    initialValue: editInfo.api,
                                    rules: [
                                        {
                                            pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                                            required: true,
                                            message: '请输入api',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                        ) : null}

                        {/* {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="是否回传">
                              {getFieldDecorator('passBack', {
                                initialValue: editInfo.passBack,
                                })(
                                    <RadioGroup >
                                       <Radio value={0}>是</Radio>
                                       <Radio value={1}>否</Radio>
                                    </RadioGroup>,
                               )}
                            </FormItem>
                        ) : null} */}
                        {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="点击回传">
                            {getFieldDecorator('isClickPassBack', {
                              initialValue: editInfo.isClickPassBack,
                              })(
                                  <RadioGroup >
                                     <Radio value={0}>是</Radio>
                                     <Radio value={1}>否</Radio>
                                  </RadioGroup>,
                             )}
                            </FormItem>
                        ) : null}
                        {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="曝光回传">
                            {getFieldDecorator('isEvPassBack', {
                              initialValue: editInfo.isEvPassBack,
                              })(
                                  <RadioGroup >
                                     <Radio value={0}>是</Radio>
                                     <Radio value={1}>否</Radio>
                                  </RadioGroup>,
                             )}
                            </FormItem>
                        ) : null}
                       {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="是否串行">
                            {getFieldDecorator('isBunchExecute', {
                              initialValue: editInfo.isBunchExecute,
                              })(
                                  <RadioGroup >
                                     <Radio value={0}>是</Radio>
                                     <Radio value={1}>否</Radio>
                                  </RadioGroup>,
                             )}
                            </FormItem>
                        ) : null}
                       {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="是否首条先执行">
                            {getFieldDecorator('isFirstExecute', {
                              initialValue: editInfo.isFirstExecute,
                              })(
                                  <RadioGroup >
                                     <Radio value={1}>是</Radio>
                                     <Radio value={0}>否</Radio>
                                  </RadioGroup>,
                             )}
                            </FormItem>
                        ) : null}

                        {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="素材是否使用真实ip">
                            {getFieldDecorator('isApiMaterialUseRealIp', {
                              initialValue: editInfo.isApiMaterialUseRealIp,
                              })(
                                  <RadioGroup >
                                     <Radio value={1}>是</Radio>
                                     <Radio value={0}>否</Radio>
                                  </RadioGroup>,
                             )}
                            </FormItem>
                        ) : null}


                        {(editInfo.taskSource == 'api' || editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike' || editInfo.taskSource== 'brandDsp')  ? (
                            <FormItem {...formItemLayout} label="时间间隔">
                                {getFieldDecorator('evClickIntervalTime', {
                                    initialValue: editInfo.evClickIntervalTime,
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                        ) : null}

                        {(editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike') ? (
                          <FormItem {...formItemLayout} label="兴趣">
                                {getFieldDecorator('interest', {
                                    initialValue: editInfo.interest,
                                    rules: [
                                        {
                                            required: false,
                                            message: '至少选择一个标签',
                                        },
                                    ],
                                })(
                                    <Select
                                        multiple
                                        placeholder="兴趣"
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {labelList.filter((label, index) => {
                                            return label.type == 'i';
                                        }).map((label, index) => {
                                            return <Option key={label.id} title={label.labelName} value={label.id}>{label.labelName}</Option>
                                        })}
                                    </Select>,
                                )}
                          </FormItem>
                        ) : null}
                        {(editInfo.taskSource == 'accurateOperations' || editInfo.taskSource == 'lookalike') ? (
                          <FormItem {...formItemLayout} label="用户信息">
                              {getFieldDecorator('userInfo', {
                                  initialValue: editInfo.userInfo,
                                  rules: [
                                      {
                                          required: false,
                                          message: '至少选择一个标签',
                                      },
                                  ],
                              })(
                                  <Select
                                      multiple
                                      placeholder="用户信息"
                                      allowClear
                                      optionFilterProp="children"
                                      filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                  >
                                    {labelList.filter((label, index) => {
                                        return label.type == 's';
                                    }).map((label, index) => {
                                        return <Option key={label.id} title={label.labelName} value={label.id}>{label.labelName}</Option>
                                    })}
                                  </Select>,
                              )}
                          </FormItem>
                        ) : null}
                       
                        <FormItem {...formItemLayout} label="设备类型">
                            {getFieldDecorator('deviceInfo', {
                                initialValue: editInfo.deviceInfo,
                                rules: [{ message: '请选择设备类型' }],
                            })(
                                <Select onChange={this.handleChangeDeviceInfo.bind(this)}>
                                    <Option value="DEFAULT">默认</Option>
                                    <Option value="ANDROID">安卓</Option>
                                    <Option value="IPHONE">IOS</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {/* <FormItem {...formItemLayout} label="安卓占比">
                            {getFieldDecorator('androidRatio', {
                                initialValue: editInfo.androidRatio,
                            })(<Slider  marks={marks} min={0} max={10}  />)}
                        </FormItem> */}
                        <FormItem {...formItemLayout} label="安卓占比">
                                {getFieldDecorator('androidRatio', {
                                    initialValue: editInfo.androidRatio,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '格式不正确',
                                        },
                                    ],
                                })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="平台">
                            {getFieldDecorator('platform', {
                                initialValue: editInfo.platform,
                                rules: [{ message: '请选择设备类型' }],
                            })(
                                <Select>
                                    <Option value="APP">APP</Option>
                                    <Option value="WAP">WAP</Option>
                                    <Option value="PC">PC</Option>
                                    <Option value="OTT">OTT</Option>
				    <Option value="PAD">PAD</Option>
                                </Select>,
                            )}
                        </FormItem>
                        {curveList.length > 0 ? <FormItem {...formItemLayout} label="曲线基准">
                            {getFieldDecorator('curve', {
                                initialValue: editInfo.curve,
                                rules: [
                                    {
                                        required: false,
                                    },
                                ],
                            })(
                              <Select allowClear placeholder="曲线基准" style={{ width: 200 }}>
                                  {curveList.map((item, index) => {
                                      return (
                                          <Option key={index} value={item}>
                                              {item}
                                          </Option>
                                      );
                                  })}
                              </Select>
                                // <Select
                                //     multiple
                                //     placeholder="曲线基准"
                                //     allowClear
                                //     optionFilterProp="children"
                                //     filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                // >
                                //     {curveList.map((curve, index) => {
                                //         return <Option key={curve} title={curve} value={curve}>{curve}</Option>
                                //     })}
                                // </Select>,
                            )}
                        </FormItem> : null}
                        {/* <FormItem {...formItemLayout} label="广告位置">
                            {getFieldDecorator('taskPosition', {
                                initialValue: editInfo.taskPosition,
                                rules: [{ message: '请选择广告位置' }],
                            })(
                                <Select onChange={this.changeTaskPosition}>
                                    <Option value="DEFAULT">默认</Option>
                                    <Option value="TOP">首页</Option>
                                    <Option value="BOTTOM">底部</Option>
                                </Select>,
                            )}
                        </FormItem> */}
                        <FormItem {...formItemLayout} label="结束方式">
                            {getFieldDecorator('endType', {
                                initialValue: editInfo.endType,
                            })(
                                <Select placeholder="结束方式" style={{ width: '50%' }}>
                                    <Option value={0}>无</Option>
                                    <Option value={1}>到量即止</Option>
                                    <Option value={2}>无填充</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="URL">
                            {getFieldDecorator('url', {
                                initialValue: editInfo.url,
                                // rules: [
                                //     {
                                //        // pattern: /[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
                                //         required: true,
                                //         message: '请输入url',
                                //     },
                                // ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="强制到达">
                            {getFieldDecorator('forceArrive', {
                                initialValue: editInfo.forceArrive,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="S2S">
                            {getFieldDecorator('isS2S', {
                                initialValue: editInfo.isS2S,
                            })(
                                <RadioGroup >
                                <Radio value={1}>是</Radio>
                                <Radio value={0}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="指定代理商">
                            {getFieldDecorator('appointProxyName', {
                                initialValue: editInfo.appointProxyName,
                                rules: [
                                    {
                                        required: false,
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="代理商"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {agents.map((item, index) => {
                                        return <Option key={index} title={item} value={item}>{item}</Option>
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="排除代理商">
                            {getFieldDecorator('excludeProxyName', {
                                initialValue: editInfo.excludeProxyName,
                                rules: [
                                    {
                                        required: false,
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="排除-代理商"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {agents.map((item, index) => {
                                        return <Option key={index} title={item} value={item}>{item}</Option>
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        
                        <FormItem {...formItemLayout} label="独享代理池">
                            {getFieldDecorator('exclusiveProxy', {
                                initialValue: editInfo.exclusiveProxy,
                            })(
                                // <RadioGroup >
                                //     <Radio value={0}>关闭</Radio>
                                //     <Radio value={1}>开启</Radio>
                                // </RadioGroup>,
                                <Select allowClear>
                                  <Option value={0}>关闭</Option>
                                  <Option value={1}>开启(taskId)</Option>
                                  <Option value={2}>开启(eId)</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="总量控制">
                            {getFieldDecorator('tc', {
                                initialValue: editInfo.tc,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>是</Radio>
                                    <Radio value={1}>否</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="忽略阻塞限制">
                            {getFieldDecorator('ignoreThreshold', {
                                initialValue: editInfo.ignoreThreshold || 0,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="分配方式">
                            {getFieldDecorator('onTargetPv', {
                                initialValue: editInfo.onTargetPv,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>余量分配</Radio>
                                    <Radio value={1}>总量分配</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="禁用图片">
                            {getFieldDecorator('disableImg', {
                                initialValue: editInfo.disableImg,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="是否追投">
                            {getFieldDecorator('isAdditional', {
                                initialValue: editInfo.isAdditional,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>按设备ID</Radio>
                                    <Radio value={2}>按IP</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="重写Canvas">
                            {getFieldDecorator('isOverwriteCanvas', {
                                initialValue: editInfo.isOverwriteCanvas,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>否</Radio>
                                    <Radio value={1}>是</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="目标量">
                            {getFieldDecorator('targetPv', {
                                initialValue: editInfo.targetPv,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确目标量',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input />)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="溢出量">
                            {getFieldDecorator('overflowRate', {
                                initialValue: editInfo.overflowRate != 10 && editInfo.overflowRate != 20 && editInfo.overflowRate != 30 ? 40 : editInfo.overflowRate,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入溢出量',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(
                                <RadioGroup onChange={this.changeFlow}>
                                    <Radio value={10}>10%</Radio>
                                    <Radio value={20}>20%</Radio>
                                    <Radio value={30}>30%</Radio>
                                    <Radio value={40}>自定义</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>
                        {editInfo.overflowRate != 10 && editInfo.overflowRate != 20 && editInfo.overflowRate != 30 ? (
                            <FormItem {...formItemLayout} label="自定义溢出比例">
                                {getFieldDecorator('overflow', {
                                    initialValue: editInfo.overflowRate,
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入溢出量比例，如10',
                                            //pattern: /^\d+$/,
                                        },
                                    ],
                                })(<Input placeholder="请填入比例，如10" />)}
                            </FormItem>
                        ) : null}
                        <FormItem {...formItemLayout} label="溢出标准值">
                            {getFieldDecorator('standardOverflowRate', {
                                initialValue: editInfo.standardOverflowRate == null ? 0 : editInfo.standardOverflowRate,
                                rules: [
                                    {
                                        required: false,
                                        message: '',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input style={{width:'20%'}} />)}
                            &nbsp;&nbsp;&nbsp;down:&nbsp;
                            {getFieldDecorator('reduceFlowRate', {
                                initialValue: editInfo.reduceFlowRate,
                            })(<Input style={{width:'20%'}} />
                            )}&nbsp;up:&nbsp;
                            {getFieldDecorator('addFlowRate', {
                                initialValue: editInfo.addFlowRate,
                            })(<Input style={{width:'20%'}} />
                            )}
                        </FormItem>


                        <FormItem {...formItemLayout} label="ivt阈值">
                            {getFieldDecorator('ivt', {
                                initialValue: editInfo.ivt == null ? 0 : editInfo.ivt,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入正确ivt阈值',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(<Input style={{width:'50%'}} />)}
                            {getFieldDecorator('realTimeIvt', {
                                initialValue: editInfo.realTimeIvt,
                            })(
                                <Select placeholder="是否实时" style={{width:'50%'}} >
                                    <Option value={0}>不实时</Option>
                                    <Option value={1}>实时</Option>
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="启用截图">
                            {getFieldDecorator('screenshots', {
                                initialValue:  editInfo.screenshots == null ? 0 : editInfo.screenshots,
                            })(
                                <RadioGroup >
                                    <Radio value={0}>关闭</Radio>
                                    <Radio value={1}>开启</Radio>
                                </RadioGroup>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="定向省份">
                            {getFieldDecorator('provinces', {
                                initialValue: editInfo.provinces,
                                rules: [
                                    {
                                        required: false,
                                        message: '至少选择一个',
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="投放省份"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {provinceList.map((province, index) => {
                                        return <Option key={province.id} title={province.name} value={province.id}>{province.name}</Option>
                                    })}
                                </Select>,
                            )}
                        </FormItem>
                        <FormItem {...formItemLayout} label="非定向省份">
                            {getFieldDecorator('excludeProvinces', {
                                initialValue: editInfo.excludeProvinces,
                                rules: [
                                    {
                                        required: false,
                                        message: '至少选择一个',
                                    },
                                ],
                            })(
                                <Select
                                    multiple
                                    placeholder="非投放省份"
                                    allowClear
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    {provinceList.map((province, index) => {
                                        return <Option key={province.id} title={province.name} value={province.id}>{province.name}</Option>
                                    })}
                                </Select>,
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="所属集群">
                            {getFieldDecorator('belongCluster', {
                                initialValue: editInfo.belongCluster,
                            })(<Select allowClear placeholder="全部" style={{ width: 200 }}>
                                {clusterList.map((item, index) => {
                                    return (
                                        <Option key={index} value={item}>
                                            {item}
                                        </Option>
                                    );
                                })}
                            </Select>)}
                        </FormItem>
                        <FormItem {...formItemLayout} label="启用时间">
                            <div>
                                <div style={{ width: 290, border: '1px solid #d9d9d9', borderRadius: 4 }}>
                                    {getFieldDecorator('filtration', {
                                        initialValue: moment(today, 'YYYY-MM-DD'),
                                        rules: [{ required: true, message: '请选择过滤时间' }],
                                    })(
                                        <Calendar
                                            fullscreen={false}
                                            onSelect={this.selectData.bind(this)}
                                            dateCellRender={this.dateCellRender}
                                        />,
                                    )}
                                </div>
                                <div className="selectedData">
                                    {editInfo.filtration
                                        ? editInfo.filtration.map((v, k) => {
                                            return (
                                                <span>
                                                    {v}
                                                    <o
                                                        onClick={() => {
                                                            this.removeData(k);
                                                        }}>
                                                        x
                                                      </o>
                                                </span>
                                            );
                                        })
                                        : null}
                                </div>
                            </div>
                        </FormItem>

                        {/*<FormItem {...formItemLayout} label="时间段">
                            {getFieldDecorator('beginTime', {
                                initialValue: moment(
                                    editInfo.timePairs ? stringToTime(editInfo.timePairs[0].beginTime) : '00:00',
                                    'HH:mm',
                                ),
                                rules: [{ type: 'object', require: true, message: '请选择时间段' }],
                            })(<TimePicker format="HH:mm" />)}
                            {getFieldDecorator('endTime', {
                                initialValue: moment(
                                    editInfo.timePairs ? stringToTime(editInfo.timePairs[0].endTime) : '23:59',
                                    'HH:mm',
                                ),
                                rules: [{ type: 'object', require: true, message: '请选择时间段' }],
                            })(<TimePicker format="HH:mm" style={{ padding: '0 0 0 10px' }} />)}
                        </FormItem>*/}

                        <FormItem {...formItemLayout} label="时间段">
                            {getFieldDecorator('timePairs', {
                                initialValue: editInfo.timePairs
                            })(
                              <TimePairsSelect/>
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label="PV频次及占比">
                            {getFieldDecorator('pvDistributeEntities', {
                                initialValue: editInfo.pvDistributeEntities
                            })(
                              <PvcRatio/>
                            )}
                        </FormItem>

                        <div style={{ display: this.state.role == 1 ? 'block' : 'none' }}>
                            <FormItem {...formItemLayout} label="等待时长（s）">
                                {getFieldDecorator('waitTimeout', {
                                    initialValue: editInfo.waitTimeout,
                                    rules: [
                                        {
                                            message: '请输入正确等待时长（s）',
                                            pattern: /^\d+$/,
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            {/* <FormItem {...formItemLayout} label="强制等待">
                                {getFieldDecorator('forceWait', {
                                    initialValue: editInfo.forceWait,
                                })(
                                    <RadioGroup >
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem> */}
                            <FormItem {...formItemLayout} label="代理有效时长">
                                {getFieldDecorator('forceWait', {
                                    initialValue: editInfo.forceWait,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入代理有效时长数值',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="UV占比">
                                {getFieldDecorator('pvToUvRatio', {
                                    initialValue: editInfo.pvToUvRatio,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确UV占比',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="利用次数">
                                {getFieldDecorator('ipReusedTimes', {
                                    initialValue: editInfo.ipReusedTimes,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确利用次数',
                                        },
                                    ],
                                })(<Input style={{width:'50%'}} />)}
                                {getFieldDecorator('ipDiffByTaskOrEid', {
                                    initialValue: editInfo.ipDiffByTaskOrEid,
                                })(
                                    <Select placeholder="控制域" style={{width:'50%'}} >
                                        <Option value={0}>根据taskId</Option>
                                        <Option value={1}>根据eId</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="ip使用范围">
                                {getFieldDecorator('ipRange', {
                                    initialValue: editInfo.ipRange,
                                })(
                                    <Select>
                                        <Option value="0">全部ip</Option>
                                        <Option value="1">去除黑名单ip</Option>
                                        <Option value="2">IP地域过滤</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="ip利用次数单位时间">
                                {getFieldDecorator('ipInterval', {
                                    initialValue: editInfo.ipInterval,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的单位时间',
                                        },
                                    ],
                                })(<InputNumber  />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="单位时间ip利用次数">
                                {getFieldDecorator('ipUnitReuseTimes', {
                                    initialValue: editInfo.ipUnitReuseTimes,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的ip利用次数',
                                        },
                                    ],
                                })(<InputNumber  />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="引擎">
                                {getFieldDecorator('engine', {
                                    initialValue: editInfo.engine
                                })(
                                    <Select onChange={this.handleEngine.bind(this)}  style={{ width: 200 }}>
                                        <Option value="PHANTOMJS">PhantomJS</Option>
                                        <Option value="CHROME">Chrome</Option>
                                        <Option value="CHROMIUM">Chromium</Option>
                                        <Option value="APP">App</Option>
                                        <Option value="APPLAUNCH">AppLaunch</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="主脚本地址">
                                {getFieldDecorator('mainScriptPath', {
                                    initialValue: editInfo.mainScriptPath,
                                    rules: [{ required: true, message: '请选择类型' }],
                                })(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {primaryScripts.filter((item, index) => {
                                            let engine = editInfo.engine;
                                            if (engine === 'CHROMIUM') {
                                                engine = 'CHROME';
                                            }

                                            return item.source == engine;
                                        }).map((item, index) => {
                                            return (
                                                <Option key={index} value={item.path}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="脚本地址">
                                {getFieldDecorator('scriptPath', {
                                    initialValue: editInfo.scriptPath,
                                    rules: [
                                        {
                                            // required: editInfo.taskPosition == 'DEFAULT' ? false : true,
                                            required: false,
                                            message: '请输入脚本地址',
                                        },
                                    ],
                                })(<Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {otherScripts.filter((item, index) => {
                                        let engine = editInfo.engine == 'PHANTOMJS' ? 'PHANTOMJS' : 'CHROME';
                                        return item.source == engine;
                                    }).map((item, index) => {
                                        return (
                                            <Option key={index} value={item.path}>
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                                </Select>)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="客户端分组id">
                                {getFieldDecorator('groupId', {
                                    initialValue: editInfo.groupId,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的分组id',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="异步请求">
                                {getFieldDecorator('isAsynRequest', {
                                    initialValue: editInfo.isAsynRequest,
                                })(
                                    <RadioGroup >
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="强制互动">
                                {getFieldDecorator('forceInteraction', {
                                    initialValue: editInfo.forceInteraction,
                                })(
                                    <RadioGroup >
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="检测公司预警">
                                {getFieldDecorator('interactionAlarm', {
                                    initialValue: editInfo.interactionAlarm,
                                })(
                                    <RadioGroup >
                                        <Radio value={0}>关闭</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="自动修改溢出">
                                {getFieldDecorator('autoUpdateOverFlowRate', {
                                    initialValue: editInfo.autoUpdateOverFlowRate,
                                })(
                                    <RadioGroup >
                                        <Radio value={0}>禁用</Radio>
                                        <Radio value={1}>开启</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="执行脚本">
                                {getFieldDecorator('executeScript', {
                                    initialValue: editInfo.executeScript
                                })(<Input />)}
                            </FormItem>
                             <FormItem {...formItemLayout} label="脚本互动比例">
                                {getFieldDecorator('shellProportion', {
                                    initialValue: editInfo.shellProportion,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的脚本互动比例',
                                        },
                                    ],
                                })(<Input addonAfter="%" />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="referer">
                                {getFieldDecorator('referer', {
                                    initialValue: editInfo.referer,
                                    rules: [
                                        {
                                            message: '请输入referer',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="完成标记">
                                {getFieldDecorator('finishedFlag', {
                                    initialValue: editInfo.finishedFlag,
                                    rules: [
                                        {
                                            message: '请输入完成标记',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="请求类型">
                                {getFieldDecorator('requestType', {
                                    initialValue: editInfo.requestType,
                                })(
                                    <Select>
                                        <Option value="WEBKIT">WEBKIT</Option>
                                        <Option value="HTTP_CLIENT">HTTP_CLIENT</Option>
                                    </Select>,
                                )}
                            </FormItem>

                            <Row style={{position: 'relative'}} gutter={2} style={{marginBottom: '20px'}}>
                                <Col span={6} style={{fontSize: '12px', lineHeight: '32px', textAlign: 'right'}}>请输入行为数据：</Col>
                                <Col span={14}>
                                    <TextArea value={editInfo.behaviourData} onChange={this.changeBehaviourData}/>
                                </Col>
                                <Col span={2} style={{marginLeft: '6px'}}><Button type="danger" onClick={this.showBehaviourEdit}>转换</Button></Col>
                            </Row>

                            <FormItem {...formItemLayout} label="行为互动比例">
                                {getFieldDecorator('activeProportion', {
                                    initialValue: editInfo.activeProportion,
                                    rules: [
                                        {
                                            pattern: /^\d+$/,
                                            message: '请输入正确的行为互动比例',
                                        },
                                    ],
                                })(<Input addonAfter="%" />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="互动执行延时">
                                {getFieldDecorator('behaviourDataWaitTime', {
                                    initialValue: editInfo.behaviourDataWaitTime,
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="监测代码请求期望数">
                                {getFieldDecorator('irCountExcept', {
                                    initialValue: editInfo.irCountExcept,
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="关联taskId">
                                {getFieldDecorator('connectTaskIds', {
                                    initialValue: editInfo.connectTaskIds,
                                    rules: [
                                        {
                                            message: '关联taskId',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="执行速度系数">
                                    {getFieldDecorator('speedRatio', {
                                        initialValue: editInfo.speedRatio,
                                    })(
                                    <Select>
                                        <Option value={40}>40%</Option>
                                        <Option value={60}>60%</Option>
                                        <Option value={80}>80%</Option>
                                        <Option value={100}>100%</Option>
                                        <Option value={120}>120%</Option>
                                        <Option value={140}>140%</Option>
                                        <Option value={160}>160%</Option>
                                        <Option value={180}>180%</Option>
                                        <Option value={200}>200%</Option>
                                        <Option value={220}>220%</Option>
                                        <Option value={240}>240%</Option>
                                        <Option value={260}>260%</Option>
                                        <Option value={280}>280%</Option>
                                        <Option value={300}>300%</Option>
                                        <Option value={500}>500%</Option>
                                        <Option value={800}>800%</Option>
                                        <Option value={1000}>1000%</Option>
                                        <Option value={2000}>2000%</Option>
                                    </Select>,
                                    )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="追踪取样比例(%)">
                                {getFieldDecorator('trackingSamplingRatio', {
                                    initialValue: editInfo.trackingSamplingRatio,
                                    rules: [
                                        {
                                            message: '取值为0-100',
                                            pattern: /^(?:[1-9]?\d|100)$/,
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>

                            <FormItem {...formItemLayout} label="追踪有效时间">
                                 {getFieldDecorator('trackDelayTime', {
                                     initialValue: editInfo.trackDelayTime,
                                 })(
                                     <Select onChange={this.handleTrackDelayTime} allowClear>
                                         <Option value="1">1分钟</Option>
                                         <Option value="2">2分钟</Option>
                                         <Option value="3">3分钟</Option>
                                         <Option value="4">4分钟</Option>
                                         <Option value="5">5分钟</Option>
                                         <Option value="6">6分钟</Option>
                                         <Option value="7">7分钟</Option>
                                         <Option value="8">8分钟</Option>
                                         <Option value="9">9分钟</Option>
                                         <Option value="10">10分钟</Option>
                                    </Select>,
                                )}
                                </FormItem>

                        
                            <FormItem {...formItemLayout} label="追踪结束时间">
                            {getFieldDecorator('trackingFinishTime', {
                                initialValue: (editInfo.trackDelayTime!=null && editInfo.trackDelayTime!=undefined) ? moment(delayTimeToFinishTime(editInfo.trackDelayTime), 'YYYY-MM-DD HH:mm:ss') : (editInfo.trackingFinishTime!=null && editInfo.trackingFinishTime!=undefined)?moment(timeStampToStr(editInfo.trackingFinishTime), 'YYYY-MM-DD HH:mm:ss'):""
                            })(<DatePicker
                                showTime
                                format="YYYY-MM-DD HH:mm:ss"
                                placeholder="选择时间"
                                allowClear={false}
                                disabled
                                />)
                            }
                            </FormItem>
                            
                            <FormItem {...formItemLayout} label="点击率">
                                {getFieldDecorator('clickRate', {
                                    initialValue: editInfo.clickRate,
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="点击率分组">
                                {getFieldDecorator('clickRateFlag', {
                                    initialValue: editInfo.clickRateFlag,
                                    rules: [
                                        {
                                            message: '请输入',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="任务关联关键字">
                                    {getFieldDecorator('connectKey', {
                                        initialValue: editInfo.connectKey,
                                    })(
                                        <Select>
                                            <Option value="splash_gdt">splash_gdt</Option>
                                            <Option value="splash_csj">splash_csj</Option>
                                            <Option value="banner_gdt">banner_gdt</Option>
                                            <Option value="banner_csj">banner_csj</Option>
                                            <Option value="flow_gdt">flow_gdt</Option>
                                            <Option value="flow_csj">flow_csj</Option>
                                            <Option value="pop_gdt">pop_gdt</Option>
                                            <Option value="pop_csj">pop_csj</Option>
                                            <Option value="">空</Option>
                                        </Select>,
                                    )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="到达率">
                                {getFieldDecorator('hzArrivalRate', {
                                    initialValue: editInfo.hzArrivalRate,
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="附加信息">
                                {getFieldDecorator('dependentType', {
                                    initialValue: editInfo.dependentType,
                                    rules: [
                                        {
                                            pattern: /\d+/,
                                            message: '请输入数字',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>

                            <FormItem {...formItemLayout} label="是否回传安卓id">
                                {getFieldDecorator('isAndroidIdPassBack', {
                                    initialValue: editInfo.isAndroidIdPassBack,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否回传Mac">
                                {getFieldDecorator('isMacPassBack', {
                                    initialValue: editInfo.isMacPassBack,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="是否回传oaId">
                                {getFieldDecorator('isOaIdPassBack', {
                                    initialValue: editInfo.isOaIdPassBack,
                                })(
                                    <RadioGroup>
                                        <Radio value={0}>否</Radio>
                                        <Radio value={1}>是</Radio>
                                    </RadioGroup>,
                                )}
                            </FormItem>

                            <FormItem {...formItemLayout} label="素材格式预警">
                                {getFieldDecorator('materialFormatWarning', {
                                    initialValue: editInfo.materialFormatWarning,
                                })(
                                    <Select>
                                        <Option value={0}>关闭</Option>
                                        <Option value={1}>打开</Option>
                                    </Select>,
                                )}
                            </FormItem>

                            <FormItem {...formItemLayout} label="期望溢出">
                                {getFieldDecorator('expectOverFlow', {
                                    initialValue: editInfo.expectOverFlow,
                                    rules: [
                                        {
                                            required: false,
                                            message: '请输入',
                                        },
                                    ],
                                })(<Input />)}
                            </FormItem>

                            <FormItem {...formItemLayout} label="请求是否获取360参数">
                                {getFieldDecorator('needRequestData', {
                                    initialValue: editInfo.needRequestData,
                                })(
                                    <Select>
                                        <Option value={0}>不需要</Option>
                                        <Option value={1}>需要</Option>
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="检测公司">
                                {getFieldDecorator('monitorNames', {
                                    initialValue: editInfo.monitorNames,
                                    rules: [
                                        {
                                            required: false,
                                            message: '至少选择一个标签',
                                        },
                                    ],
                                })(
                                    <Select
                                        multiple
                                        placeholder="检测公司"
                                        allowClear
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {moniterNameList.map((label, index) => {
                                            return <Option key={label.monitoringName} title={label.monitoringName} value={label.monitoringName}>{label.monitoringName}</Option>
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                            <FormItem {...formItemLayout} label="任务组">
                                {getFieldDecorator('creatorGroupId', {
                                    initialValue: editInfo.creatorGroupId,
                                })(<Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {groupList.map((item, index) => {
                                        return (
                                            <Option key={index} value={item._id}>
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                                </Select>)}
                            </FormItem>
                            <FormItem {...formItemLayout} label="责任人">
                                {getFieldDecorator('principal', {
                                    initialValue: editInfo.principal,
                                })(<Select allowClear placeholder="全部" style={{ width: 200 }}>
                                    {userList.map((item, index) => {
                                        return (
                                            <Option key={index} value={item.name}>
                                                {item.name}
                                            </Option>
                                        );
                                    })}
                                </Select>)}
                            </FormItem>
                        </div>
                    </Form>
                </Modal>
                <BehaviourMask behaviourData={editInfo.behaviourData} editBehavior={editBehavior} hideBehaviorMask={this.hideBehaviorMask} changeEditInfo={this.props.changeEditInfo}/>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    ListLoading: state.tasklist.ListStatus.loading,
    taskList: state.tasklist.List,
    editStatus: state.tasklist.ListStatus.editShow,
    editInfo: state.tasklist.EditInfo,
    root: state.tasklist.Root,
    task: state.tasklist,
    provinceList: state.tasklist.ProvinceList,
    primaryScripts: state.tasklist.primaryScripts,
    otherScripts: state.tasklist.otherScripts,
    clusterList: state.tasklist.ClusterList,
    outTaskCategoryList: state.tasklist.OutTaskCategoryList,
    groupList: state.tasklist.GroupList,
    agents: state.tasklist.agents,
    labelList: state.tasklist.LabelList,
    moniterNameList: state.tasklist.moniterNameList,
    curveList: state.tasklist.curveList,
    userList: state.tasklist.UserList,//用户列表
    accountList: state.tasklist.accountList,
});

const mapDispatchToProps = dispatch => ({
    getList: param => dispatch(getList(param)),
    changeEditStatus: status => dispatch(createEditShowAction(status)),
    toSubmit: param => dispatch(submitToMD(param)),
    toInsert: param => dispatch(insertToMD(param)),
    updateTime: param => dispatch(createEditTimeAction(param)),
    updateOverflow: param => dispatch(createEditOverflowRateAction(param)),
    updateIpReusedTimes: param => dispatch(createEditIpReusedTimesAction(param)),
    updateTaskType: param => dispatch(createEditTaskTypeAction(param)),
    updateAndroidRatio: param => dispatch(createEditAndroidRatioAction(param)),
    updateEngine: param => dispatch(createEditEngineAction(param)),
    updateMainScript: param => dispatch(createEditMainScriptAction(param)),
    updateScript: param => dispatch(createEditScriptAction(param)),
    updateWaitTimeout: param => dispatch(createEditWaitTimeoutAction(param)),
    updatePvToUvRatio: param => dispatch(createEditPvToUvRatioAction(param)),
    updateForceWait: param => dispatch(createEditForceWaitAction(param)),
    updateProvince: param => dispatch(createEditProvinceAction(param)),
    updateTaskSource: param => dispatch(createEditTaskSource(param)),
    updateTrackDelayTime: param => dispatch(createEditTrackDelayTime(param)),
    updateTimePairs: param => dispatch(createEditTimePairsAction(param)),
    updateTaskPosition: param => dispatch(createEditTaskPosition(param)),
    getProvinceList: () => dispatch(getProvinceList()),
    getScripts: () => dispatch(getPrimaryAndOtherScript()),
    getClusterList: () => dispatch(getClusterList()),
    getOutTaskCategoryList: () => dispatch(getOutTaskCategoryList()),
    getGroupList: () => dispatch(getGroupList()),
    getAgentsAndAreas: () => dispatch(getAgentsAndAreas()),
    getLabelList: () => dispatch(getLabelList()),
    getMonitorList:() => dispatch(getMonitorList()),
    getCurveList: () => dispatch(getCurveList()),
    changeEditInfo: data => dispatch(changeEditInfo(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(EditTask));



// WEBPACK FOOTER //
// ./pages/task/tasklist/edit.js